import { OrderHeaderURLs } from '../../../../baseComponents/TwinTable/InputTableLayout/types'

const useSellDeliveryNoteHeaderUrls = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '/api/app/order/sell/sellDeliveryNote/orderCost/createSellDeliveryNoteCost',
        updateCost: '/api/app/order/sell/sellDeliveryNote/orderCost/updateSellDeliveryNoteCost',
        deleteCost: '/api/app/order/sell/sellDeliveryNote/orderCost/deleteSellDeliveryNoteCost',
        createFinancialRow: '/api/app/order/sell/sellDeliveryNote/orderFinancialRow/createSellDeliveryNoteFinancialRow',
        updateFinancialRow: '/api/app/order/sell/sellDeliveryNote/orderFinancialRow/updateSellDeliveryNoteFinancialRow',
        deleteFinancialRow: '/api/app/order/sell/sellDeliveryNote/orderFinancialRow/deleteSellDeliveryNoteFinancialRow',
        createAccount: '/api/app/order/sell/sellDeliveryNote/orderAccount/createSellDeliveryNoteAccount',
        updateAccount: '/api/app/order/sell/sellDeliveryNote/orderAccount/updateSellDeliveryNoteAccount',
        deleteAccount: '/api/app/order/sell/sellDeliveryNote/orderAccount/deleteSellDeliveryNoteAccount',
        createShipping: '/api/app/order/sell/sellShipping/createSellDeliveryNoteShipping',
        updateShipping: '/api/app/order/sell/sellShipping/updateSellDeliveryNoteShipping',
        createVariable: '/api/app/order/sell/sellDeliveryNote/orderVariable/createSellDeliveryNoteVariable',
        updateVariable: '/api/app/order/sell/sellDeliveryNote/orderVariable/updateSellDeliveryNoteVariable',
        deleteVariable: '/api/app/order/sell/sellDeliveryNote/orderVariable/deleteSellDeliveryNoteVariable',
        updateWorkingCenter: '/api/app/order/sell/sellDeliveryNote/updateSellDeliveryNoteWorkingCenter',
        createUpdateProductTypes: '/api/app/order/sell/sellDeliveryNote/orderProductType/createUpdateSellDeliveryNoteProductTypes',
    }
    return orderHeaderURLs
}

export default useSellDeliveryNoteHeaderUrls